import { CircularProgress, Stack } from '@mui/material';

export const LoadingScreen = () => {
  return (
    <Stack
      flex={1}
      justifyContent={'center'}
      alignItems="center"
      height="100dvh"
      maxHeight="100%"
    >
      <CircularProgress />
    </Stack>
  );
};
